import { useEffect } from "react";

const PRINT_PAGE_WIDTH = 1000;

export const usePrintScale = (containerId: string) => {
    useEffect(() => {
        const getContainer = () => document.getElementById(containerId);

        const onBeforePrint = () => {
            const container = getContainer();
            if (!container) return;

            const sidebar = container.querySelector<HTMLElement>(".employee-list-container");
            const grid = container.querySelector<HTMLElement>(".schedule-grid-content");
            if (!grid) return;

            const contentWidth =
                (sidebar?.offsetWidth ?? 0) + Math.max(grid.scrollWidth, grid.offsetWidth);
            if (!contentWidth) return;

            const scale = Math.min(1, PRINT_PAGE_WIDTH / contentWidth);
            // Exposed as a variable (applied only under @media print) - an inline `zoom` would
            // also shrink the on-screen page while the print dialog is open
            container.style.setProperty("--print-zoom", `${scale}`);
        };

        const onAfterPrint = () => {
            const container = getContainer();
            if (container) container.style.removeProperty("--print-zoom");
        };

        window.addEventListener("beforeprint", onBeforePrint);
        window.addEventListener("afterprint", onAfterPrint);
        return () => {
            window.removeEventListener("beforeprint", onBeforePrint);
            window.removeEventListener("afterprint", onAfterPrint);
        };
    }, [containerId]);
};
